module.exports = __webpack_public_path__ + "img/file-2.435cb0be.svg";